import { request } from "../axios";
import { encodeQueryData, handleApiError } from "../helper";
import { KEYS } from "./keys";
import type { AuthSessionResponse, NonceResponse, VerifyResponse } from "./types";

export async function getAuthNonce(address: string): Promise<NonceResponse> {
  try {
    const query = encodeQueryData({ address });
    const { data } = await request.get<NonceResponse>(`${KEYS.AUTH_NONCE}?${query}`);
    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}

export async function verifyAuthMessage(payload: {
  message: string;
  signature: string;
}): Promise<VerifyResponse> {
  try {
    const { data } = await request.post<VerifyResponse>(KEYS.AUTH_VERIFY, payload);
    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}

export async function getAuthSession(): Promise<AuthSessionResponse> {
  try {
    const { data } = await request.get<AuthSessionResponse>(KEYS.AUTH);
    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}
